<template>
  <div :class="jel_getClassObject(content)">
    <Titre
      :content="{
        titre: content.libTitreMotDePasse,
        type: 'titre',
        classesCss: 'pt-1',
      }"
    />
    <MessageMel
      v-if="isErreurSessionExpire && contentMessage.sessionExpire"
      class="mb-0 mt-1"
      :content="contentMessage.sessionExpire"
    />

    <!-- TODO: ajouter la date de dernière modification (en attente de OB) -->
    <!-- <span>{{ content.libDerniereModification }}</span> -->
    <MessageMel
      v-if="isCourrielEnvoye"
      class="mt-1 mb-2"
      :content="contentMessage.courrielEnvoye"
    />
    <button v-else class="bouton lienPrimaire p-0" @click="envoyerCourriel()">
      {{ content.libBoutonChangerMotDePasse }}
    </button>
    <MessageMel v-if="isCourrielEnvoyeErreur" class="mt-1 mb-0" :content="contentMessage.erreur" />
  </div>
</template>

<script>
import Cookies from 'js-cookie';

import api from '@/services/api';

import MessageMel from '@/components/base/MessageMel';
import Titre from '@/components/base/Titre';

import MessageHelpers from '@/helpers/MessageHelpers';
import { getProductSourceFromQueryParams } from '@/helpers/ProductSourceHelpers';

export default {
  name: 'FormulaireSecuriteMotDePasse',
  components: {
    MessageMel,
    Titre,
  },
  props: { content: { type: Object, required: true } },
  data() {
    return {
      isCourrielEnvoye: false,
      isCourrielEnvoyeErreur: false,
      isErreurSessionExpire: true,
      contentMessageCourrielEnvoye: {},
      contentMessage: {
        courrielEnvoye: {},
        erreur: {},
        sessionExpire: {},
      },
    };
  },
  methods: {
    envoyerCourriel() {
      const withCredentials = {
        withCredentials: true,
      };
      const productSource = getProductSourceFromQueryParams();
      api
        .call(
          'ce-portal/portal_api/account/account/password/reset-email',
          'courrielEnvoyeMdp',
          'POST',
          {
            withCredentials,
            headers: {
              'X-CSRF-TOKEN': Cookies.get('OB_REQ'),
            },
            data: {
              product_source: productSource || 'EJ',
            },
          }
        )
        .then((response) => {
          this.isCourrielEnvoye = true;
          this.isCourrielEnvoyeErreur = false;
          this.recupererMessage('MSG06-10', 'courrielEnvoye');
        })
        .catch((error) => {
          if (error.response?.data?.status === 'Unauthorized') {
            this.isErreurSessionExpire = true;
            this.recupererMessage('MSG06-00', 'sessionExpire');
          } else {
            this.isCourrielEnvoye = false;
            this.isCourrielEnvoyeErreur = true;
            this.recupererMessage('MSG06-11', 'erreur');
          }
        });
    },
    recupererMessage(codeMessage, contentMessage) {
      MessageHelpers.obtenirMessage(codeMessage, this.$root)
        .then((msgResp) => {
          this.contentMessage[contentMessage] = {
            titre: msgResp.msgTitre,
            message: msgResp.msgDetail,
            msgType: msgResp.msgType,
          };
        })
        .catch((error) => {
          console.error('Erreur de récupération du message!', error);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.bouton {
  border: none !important;
  font-size: 16px;
}
.boite-courriel-envoye {
  background-color: #e5e6ff;
  border-radius: 6px;
  padding: 12px;
}
::v-deep {
  .titre-envoi-courriel {
    padding-top: 3px;
  }
  .mel-erreur-inner {
    margin: 0 !important;
  }
  .titre {
    padding-top: 0.5rem;
  }
}
</style>
